export const fetchAddress = async (postcode, params) => {
  return window.$vue.$get({
    endpoint: `/city/postcode/${postcode}`,
    encrypt: false,
    params
  })
}

export const listCities = async payload => {
  return window.$vue.$get({ endpoint: `/city/state/${payload}` })
}

export const saveAddress = async data => {
  return window.$vue.$post({ endpoint: "/address", data })
}

export const fetchAddressComplements = async () => {
  return await window.$vue.$get({
    endpoint: "/provider/complement"
  })
}

export const fetchAddressByUserPosition = async params => {
  return await window.$vue.$get({
    endpoint: "/address/coordinates",
    params
  })
}
